import DocRenderer from "@/components/admin/DocBlocks";
import { AD_PLAN, AD_PLAN_META } from "@/content/adPlan";

export default function AdPlanDoc() {
  return <DocRenderer meta={AD_PLAN_META} sections={AD_PLAN} testId="ad-plan-doc" />;
}
